<template>
    <div>
        <el-select v-model="languageValue_n" @change="changeLanguage" placeholder="请选择">
            <el-option v-for="item in languageOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    data() {
        return {
            languageValue_n: '',
            languageOptions: [
                { value: 'zh', label: 'China' },
                { value: 'en', label: 'Europe' },
                { value: 'en2', label: 'Asia' },
                { value: 'en3', label: 'America' }
            ],
        }
    },
    created() {
        //最开始请求的时候看缓存是什么状态
        if (this.$i18n.locale == 'zh') {
            this.languageValue_n = 'China';
        } else if(this.$i18n.locale == 'en'){
            this.languageValue_n = 'Europe';
        } else if(this.$i18n.locale == 'en2'){
            this.languageValue_n = 'Asia';
        } else if(this.$i18n.locale == 'en3'){
            this.languageValue_n = 'America';
        }
        // console.log('加载语言', localStorage.getItem('locale'));
        this.$EventBus.$emit('this.languageValue_n', this.languageValue_n);
    },
    methods: {
        // 多语言切换
        changeLanguage(type) {
            console.log(type);
            // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
            //的时候先取localStorage的记录值
            localStorage.setItem('locale', type)
            this.$i18n.locale = type; // 修改页面需要显示的语言
            if (this.$i18n.locale == 'zh') {
                this.languageValue_n = 'China';
                this.$EventBus.$emit('this.languageValue_n', this.languageValue_n);
            } else if (this.$i18n.locale == 'en') {
                this.languageValue_n = 'Europe';
                this.$EventBus.$emit('this.languageValue_n', this.languageValue_n);
            } else if (this.$i18n.locale == 'en2') {
                this.languageValue_n = 'Asia';
                this.$EventBus.$emit('this.languageValue_n', this.languageValue_n);
            } else if (this.$i18n.locale == 'en3') {
                this.languageValue_n = 'America';
                this.$EventBus.$emit('this.languageValue_n', this.languageValue_n);
            }
            this.$router.go(0)
        },
    }
}
</script>
<style lang="scss">
    .el-select{
        width: 240px;
        margin-left: 20px;
    }
</style>
